// extracted by mini-css-extract-plugin
export default {"sessionReplayPlayer":"session_replay_player__zD7hfaxQ","loadingSpinner":"loading_spinner__WZhvHe6S"};